// extracted by mini-css-extract-plugin
export default {"over":"label-info_over__zxnna"};